<template>
  <start-page>
    <div class="login">
      <modal-title>Добро пожаловать</modal-title>

      <form v-on:submit.prevent="login()" novalidate class="login-form">
        <custom-input
          name="username"
          inputType="email"
          iconName="user"
          placeholder="Электронная почта или телефон"
          labelText="Пользователь"
          v-model="data.body.username"
        />
        <custom-input
          name="password"
          inputType="password"
          iconName="password"
          placeholder="Password"
          labelText="Пароль"
          v-model="data.body.password"
        />

        <div class="login-checkbox-group">
          <custom-checkbox
            id="remember-user"
            :value="data.rememberMe"
            v-model="data.rememberMe"
            labelText="Запомнить меня"
          />
          <inner-link to="/forgot" class="login-forgot">Забыли пароль ?</inner-link>
        </div>

        <div class="login-input-error" v-show="error">{{ error }}</div>
        <main-button class="login-button" fullWidth v-if="logging" disabled>Идёт авторизация</main-button>

        <main-button class="login-button" fullWidth v-else type="submit">Войти</main-button>
        <b-progress v-if="logging" :value="logging" variant="success" striped></b-progress>
      </form>

      <inner-link class="login-link" color="secondary" to="/register">Зарегистрироваться</inner-link>
    </div>
  </start-page>
</template>

<style scoped>
.login {
  width: 372px;
  margin: 0 auto;
  padding: 36px;
  box-shadow: 0px 3px 8px rgba(5, 6, 36, 0.15), 0px 1px 4px rgba(5, 6, 36, 0.12);
  border-radius: 6px;
  background-color: var(--white-color);
}

.login-input-error {
  width: max-content;
  max-width: 100%;
  text-align: center;
  margin: 0 auto 4px;
  color: var(--error-color);
}

.login-checkbox-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.login-button {
  margin-bottom: 24px;
}

.login-link {
  margin: 0 auto;
}
</style>

<script>
import StartPage from "./StartPage.vue";
import Button from "../ui/MainButton.vue";
import InnerLink from "../ui/InnerLink.vue";
import Checkbox from "../ui/Checkbox.vue";
import ModalTitle from "../ui/ModalTitle.vue";
import Input from "../ui/Input.vue";

export default {
  data() {
    return {
      context: "login context",
      timer: null,
      logging: false,
      data: {
        body: {
          username: "",
          password: "",
        },
        rememberMe: false,
        fetchUser: true,
      },
      error: null,
    };
  },

  components: {
    StartPage,
    "main-button": Button,
    "inner-link": InnerLink,
    "custom-checkbox": Checkbox,
    "custom-input": Input,
    ModalTitle,
  },

  methods: {
    login() {
      this.logging = 0;
      this.timer = setInterval(() => {
        if (this.logging < 100) {
          this.logging += 10;
        }
      }, 10);
      this.$auth
        .login({
          data: this.data.body, // Axios
          rememberMe: this.data.rememberMe,
          fetchUser: this.data.fetchUser,
          redirect: "/",
        })
        .then(() => {
          console.log("success " + this.context);
          clearInterval(this.timer);
          this.logging = false;
        })
        .catch((e) => {
          if (e.response) {
            this.error = e.response.data;
          }
          clearInterval(this.timer);
          this.logging = false;
        });
    },
  },
};
</script>
